
import React from 'react';
import { TableCell } from '@/components/ui/table';
import { Attendee } from '@/types/attendee';

interface NameCellProps {
  attendee: Attendee;
  isMobile: boolean;
}

export const NameCell: React.FC<NameCellProps> = ({ attendee, isMobile }) => {
  return (
    <TableCell className={`font-medium ${isMobile ? 'max-w-[90px] truncate' : ''}`} title={attendee.name}>
      {attendee.name}
    </TableCell>
  );
};
